import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import { StorageService } from './storage.js'

axios.defaults.baseURL = process.env.VUE_APP_API_PATH;
axios.defaults.headers.post['Content-Type'] = 'application/json';

// If token exists set header
let token = StorageService.getToken();
if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
}

export const ApiService = {
    init() {
        setupCache(axios, { interpretHeader: false });

        axios.interceptors.response.use(
            (response) => response,
            (error) => {
                const { response } = error;
                if (response && response.status === 401) {
                    StorageService.removeLoginData();
                    window.location.href = "/";
                }

                // Sanitization layer: Discard non-JSON or HTML responses to prevent XSS/Info leakage
                if (response) {
                    const isHtml = typeof response.data === 'string' && (response.data.includes('<!DOCTYPE html>') || response.data.includes('<html'));
                    const isNotObject = typeof response.data !== 'object';

                    if (isHtml || isNotObject) {
                        error.response.data = {
                            message: "El servidor respondió con un formato inesperado. Por seguridad, la respuesta fue bloqueada.",
                            secure: true
                        };
                    }
                }

                return Promise.reject(error);
            }
        );
    },
    removeHeader() {
        axios.defaults.headers.common = {}
    },
    get(apiPath, options = { cache: true }) {
        return axios.get(apiPath, options)
    },
    download(apiPath) {
        return axios({
            url: apiPath,
            method: 'GET',
            responseType: 'blob', // important
        })
    },
    post(apiPath, data) {
        return axios.post(apiPath, data);
    },

    postFormData(apiPath, data) {
        return axios.post(apiPath, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    put(apiPath, data) {
        return axios.put(apiPath, data)
    },

    delete(apiPath) {
        return axios.delete(apiPath)
    },
    axios() {
        return axios;
    },
}
